import { map } from "nanostores";

import { Entity, getEntity, listTopEntities, searchEntities } from "../api";
import {
  buildResourceAsyncSelectCacheMessages,
  useResourceAsyncSelectCache,
} from "./useResourceAsyncSelectCache";

const $entityCache = map<Record<string, Entity>>({});

const MESSAGES = buildResourceAsyncSelectCacheMessages("entity", {
  loadInitialPrefix: "top ",
});

const fetchEntityById = async (id: string): Promise<Entity | null> => {
  const result = await getEntity({ path: { entityId: id } });
  return result.data ?? null;
};

const searchEntitiesForSelect = async (
  searchTerm: string,
): Promise<Entity[]> => {
  const result = await searchEntities({
    query: { searchTerm },
  });
  return result.data ?? [];
};

const loadDefaultEntities = async (): Promise<Entity[]> => {
  const result = await listTopEntities({
    query: { limit: 10 },
  });
  return result.data ?? [];
};

export const useEntityCache = (): {
  entities: Record<string, Entity>;
  getEntityById: (id: string) => Entity | undefined;
  isLoading: boolean;
  loadEntityById: (id: string) => Promise<Entity | null>;
  loadOptions: (inputValue: string) => Promise<Entity[]>;
  searchResults: Entity[];
  selectEntity: (entity: Entity) => void;
} => {
  const base = useResourceAsyncSelectCache({
    fetchById: fetchEntityById,
    loadDefaultBatch: loadDefaultEntities,
    messages: MESSAGES,
    search: searchEntitiesForSelect,
    store: $entityCache,
  });

  return {
    entities: base.record,
    getEntityById: base.getById,
    isLoading: base.isLoading,
    loadEntityById: base.loadById,
    loadOptions: base.loadOptions,
    searchResults: base.searchResults,
    selectEntity: base.select,
  };
};
